import hash from './hash';
import MultiplexHost from './MultiplexHost';
import metrics from './sharedMetrics';
import UniqueChannelInstance from './UniqueChannelInstance';
var DEFAULTS = {
  host: '//staging-firehose.ops.pe/',
  ssl: true
};
var connections = {};
/**
 * Public interface for firehose-client
 * returns a UniqueChannelInstance which can be used to subscribe to events and unsubscribe when done
 * underlying channel connections will be reused where possible, hence the unique instance to isolate each client
 */

function subscribe(channelPath, opts) {
  if (opts === void 0) {
    opts = {};
  }

  if (channelPath[0] !== '/') {
    channelPath = "/" + channelPath;
  }

  var options = Object.assign({}, DEFAULTS, opts);
  var hostKey = hash("" + options.host + options.ssl);

  if (!connections[hostKey]) {
    connections[hostKey] = new MultiplexHost({
      ssl: options.ssl,
      host: options.host
    });
  }

  var channel = connections[hostKey].openChannel(channelPath, options);
  return new UniqueChannelInstance(channel);
}

subscribe.metrics = metrics;
export default subscribe;